import { render } from "./Path.vue?vue&type=template&id=5b4bc493&scoped=true"
import script from "./Path.vue?vue&type=script&lang=js"
export * from "./Path.vue?vue&type=script&lang=js"

import "./Path.vue?vue&type=style&index=0&id=5b4bc493&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4bc493"]])

export default __exports__